import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LockKey } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(
        `${API}/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      localStorage.setItem("vr_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-cream px-6 font-sans">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-md rounded-lg border border-black/5 bg-white p-8 shadow-[0_20px_60px_-30px_rgba(26,54,34,0.35)]"
      >
        <div className="flex items-center gap-3">
          <img
            src="/vr-logo.jpeg"
            alt="VR Ahmedabad Realtors logo"
            className="h-11 w-11 rounded-sm object-cover ring-1 ring-gold/50"
          />
          <div>
            <h1 className="font-serif text-xl text-slate-900">Admin Login</h1>
            <p className="text-xs uppercase tracking-widest text-slate-400">VR Ahmedabad Realtors</p>
          </div>
        </div>
        <div className="mt-8 space-y-5">
          <div className="space-y-2">
            <label htmlFor="admin-email" className="text-xs font-semibold uppercase tracking-widest text-slate-500">
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 w-full rounded-sm border border-slate-200 px-4 text-sm outline-none focus:border-forest focus:ring-2 focus:ring-forest/20"
              placeholder="admin@example.com"
            />
          </div>
          <div className="space-y-2">
            <label htmlFor="admin-password" className="text-xs font-semibold uppercase tracking-widest text-slate-500">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 w-full rounded-sm border border-slate-200 px-4 text-sm outline-none focus:border-forest focus:ring-2 focus:ring-forest/20"
              placeholder="••••••••"
            />
          </div>
        </div>
        {error && (
          <p data-testid="admin-login-error" className="mt-4 rounded-sm bg-red-50 px-4 py-3 text-sm text-red-700">
            {error}
          </p>
        )}
        <button
          data-testid="admin-login-submit-btn"
          type="submit"
          disabled={loading}
          className="mt-6 flex h-12 w-full items-center justify-center gap-2 rounded-sm bg-forest text-sm font-bold uppercase tracking-widest text-white transition-colors duration-200 hover:bg-forest-hover disabled:opacity-60"
        >
          <LockKey size={16} weight="bold" className="text-gold" />
          {loading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </main>
  );
}
